import {
  DASHBOARD_LOADING,
  DASHBOARD_LOADED,
  DASHBOARD_ERROR,
  SET_DASHBOARD_OVERVIEW,
  UPDATE_REALTIME_STATS,
  UPDATE_AGENT_STATUS,
  UPDATE_MATCH_STATUS,
  SET_SELECTED_AGENT,
  SET_SELECTED_MATCH
} from '../actions/dashboardActions';

const initialState = {
  loading: false,
  error: null,
  overview: {
    timestamp: null,
    agents: {
      total: 0,
      healthy: 0,
      degraded: 0,
      unhealthy: 0,
      idle: 0,
      busy: 0,
      avgCpuUsage: 0,
      avgMemoryUsage: 0,
      agents: []
    },
    matches: {
      active: 0,
      createdToday: 0,
      createdLastHour: 0,
      completedToday: 0,
      cancelledToday: 0,
      completionRate: '0%'
    },
    system: {
      logging: { totalLogs: 0, errorLogs: 0, correlations: 0 },
      eventDeduplication: { totalEvents: 0, duplicatesBlocked: 0 },
      lifecycle: { totalEvents: 0, eventTypes: {} }
    },
    onboarding: {
      windowDays: 30,
      since: null,
      totalByEvent: {},
      last24hByEvent: {},
      totalEvents: 0,
      recentEvents: []
    },
    recentActivity: []
  },
  realtimeStats: {
    timestamp: null,
    agents: { total: 0, idle: 0, busy: 0, healthy: 0 },
    matches: { active: 0, createdLastHour: 0 }
  },
  selectedAgent: null,
  selectedMatch: null
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case DASHBOARD_LOADED:
      // Avoid wiping the live agent list if a poll response arrives without agents
      return {
        ...state,
        loading: false,
        error: null,
        overview: (() => {
          const incoming = action.payload || {};
          const incomingAgents = incoming?.agents?.agents;
          const existingAgents = state?.overview?.agents?.agents;
          const shouldPreserve =
            Array.isArray(existingAgents) &&
            existingAgents.length > 0 &&
            (!Array.isArray(incomingAgents) || incomingAgents.length === 0);

          if (!shouldPreserve) return incoming;

          return {
            ...incoming,
            agents: {
              ...incoming.agents,
              agents: existingAgents
            }
          };
        })()
      };

    case SET_DASHBOARD_OVERVIEW:
      // Avoid wiping the live agent list if an overview update arrives without agents
      return {
        ...state,
        loading: false,
        error: null,
        overview: (() => {
          const incoming = action.payload || {};
          const incomingAgents = incoming?.agents?.agents;
          const existingAgents = state?.overview?.agents?.agents;
          const shouldPreserve =
            Array.isArray(existingAgents) &&
            existingAgents.length > 0 &&
            (!Array.isArray(incomingAgents) || incomingAgents.length === 0);

          if (!shouldPreserve) return incoming;

          return {
            ...incoming,
            agents: {
              ...incoming.agents,
              agents: existingAgents
            }
          };
        })()
      };
      
    case DASHBOARD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    case UPDATE_REALTIME_STATS:
      return {
        ...state,
        realtimeStats: action.payload,
        // Also update overview stats for real-time feeling
        overview: {
          ...state.overview,
          agents: {
            ...state.overview.agents,
            idle: action.payload.agents.idle,
            busy: action.payload.agents.busy
          },
          matches: {
            ...state.overview.matches,
            active: action.payload.matches.active
          }
        }
      };
      
    case UPDATE_AGENT_STATUS:
      // Upsert agent summary into the existing agent list
      return {
        ...state,
        overview: {
          ...state.overview,
          agents: {
            ...state.overview.agents,
            agents: (() => {
              const existing = state.overview.agents.agents || [];
              const idx = existing.findIndex(a => a.ip === action.payload.ip);
              if (idx === -1) {
                return [action.payload, ...existing];
              }
              return existing.map(agent =>
                agent.ip === action.payload.ip
                  ? { ...agent, ...action.payload }
                  : agent
              );
            })()
          }
        }
      };
      
    case UPDATE_MATCH_STATUS:
      // Update match in overview if it exists
      return state;
      
    case SET_SELECTED_AGENT:
      return {
        ...state,
        selectedAgent: action.payload
      };
      
    case SET_SELECTED_MATCH:
      return {
        ...state,
        selectedMatch: action.payload
      };
      
    default:
      return state;
  }
};

export default dashboardReducer;

